import React from 'react';
import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/24/outline';

const NumberInput = ({ 
  value, 
  onChange, 
  min, 
  max, 
  step = 1, 
  className = '', 
  disabled = false,
  placeholder,
  ...props 
}) => {
  const handleIncrement = () => {
    if (disabled) return;
    const newValue = (parseFloat(value) || 0) + step;
    if (max === undefined || newValue <= max) {
      onChange({ target: { value: newValue.toString() } });
    }
  };

  const handleDecrement = () => {
    if (disabled) return;
    const newValue = (parseFloat(value) || 0) - step;
    if (min === undefined || newValue >= min) {
      onChange({ target: { value: newValue.toString() } });
    }
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    if (inputValue === '' || !isNaN(inputValue)) {
      onChange(e);
    }
  };

  return (
    <div className={`relative inline-flex ${className}`}>
      <input
        type="number"
        value={value}
        onChange={handleInputChange}
        min={min}
        max={max}
        step={step}
        disabled={disabled}
        placeholder={placeholder}
        className="block w-full pr-7 py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-white text-gray-900 h-9"
        style={{ appearance: 'textfield', MozAppearance: 'textfield' }}
        {...props}
      />
      <div className="absolute inset-y-0 right-0 flex flex-col w-6 h-9">
        <button
          type="button"
          onClick={handleIncrement}
          disabled={disabled || (max !== undefined && parseFloat(value) >= max)}
          className="flex-1 border-l border-gray-300 bg-gray-50 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus:bg-gray-100 rounded-tr-md flex items-center justify-center h-4"
          tabIndex={-1}
        >
          <ChevronUpIcon className="h-3 w-3 text-gray-600" />
        </button>
        <button
          type="button"
          onClick={handleDecrement}
          disabled={disabled || (min !== undefined && parseFloat(value) <= min)}
          className="flex-1 border-l border-t border-gray-300 bg-gray-50 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus:bg-gray-100 rounded-br-md flex items-center justify-center h-4"
          tabIndex={-1}
        >
          <ChevronDownIcon className="h-3 w-3 text-gray-600" />
        </button>
      </div>
    </div>
  );
};

export default NumberInput;